import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Wrap = styled.div`
  line-height: 129.96%;
  display: flex;
  margin-bottom: 14px;
  font-size: 15px;
`

const LabelWrap = styled.div`
width: 45%;
  position: relative;
 :before {
     z-index: 1;
    content: " ";
    position: absolute;
    bottom: 0.3em;
    left: 0;
    height: 1px;
    width: 100%;
    border-bottom: 1px dashed;
    border-bottom-color: #818591;

 }
`

const Label = styled.span`
background: #ffff;
position: relative;
padding-right: 4px;
z-index: 2;
`

const Value = styled.span`
  padding-left: 5px;
  white-space: nowrap;
  font-weight: 500;
  color: #435260;;
`
const Rate = props => {
  const { children, label } = props

  return (
    <Wrap>
      <LabelWrap><Label>{label}</Label></LabelWrap>
      <Value>{children}</Value>
    </Wrap>
  )
}

Rate.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string
}

export default Rate
